// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__B1xhf","header":"ClearentDisclaimer_header__15_My","inner":"ClearentDisclaimer_inner__1pDs9"};